import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Typography from '@material-ui/core/Typography';

class PickRatesInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newRate: 0,
            rates: props.input.value || [],
        };
        this.onChange = (value) => props.input.onChange(value);
    }
    componentDidUpdate(prevProps, prevState) {
        const { duration } = this.props;
        const { rates } = this.state;
        this.onChange(rates.slice(0, duration));
    }
    addRate = e => {
        e.preventDefault();
        const { newRate, rates = [] } = this.state;
        this.setState({ rates: rates.concat(Number(newRate)) })
    }
    changeRate = e => {
        const keyCode = (e.keyCode ? e.keyCode : e.which);
        if (keyCode > 47 && keyCode < 58 || keyCode > 95 && keyCode < 107){
           e.preventDefault();
        }

        this.setState({ newRate: e.target.value })
    }
    clearRates = e => {
        e.preventDefault();
        this.setState({ rates: [] })
    }
    render() {
        const { sum, duration, meta: {touched, error} } = this.props;
        const { rates } = this.state;
        const updRates = rates.slice(0, duration);
        return (
            <FormControl variant="outlined">
                    {updRates.length > 0 ?
                        <Table padding="checkbox">
                            <TableHead>
                                <TableRow>
                                    <TableCell >Cтавка</TableCell>
                                    <TableCell>Месяц</TableCell>
                                    <TableCell >Сумма</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {updRates.map((r, i) => (
                                    <TableRow key={i}>
                                        <TableCell >{r} %</TableCell>
                                        <TableCell>{ i == updRates.length-1 ? `${i+1}-й и далее` : `${i+1}-й` }</TableCell>
                                        <TableCell >{Math.floor(sum * r / 100)} ₽</TableCell>
                                    </TableRow>)
                                )}
                            </TableBody>
                        </Table> : <Typography paragraph >{touched && error ? "Добавьте ставку" : "Процентные ставки"}</Typography>}
                    {updRates.length > 0 &&
                        <Grid container justify="center" style={{ marginTop: 5, marginBottom: 5 }} >
                            <Grid item>
                                <IconButton onClick={this.clearRates}>
                                    <HighlightOffIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    }
                {duration > updRates.length &&
                    <Grid container justify="flex-start" spacing={8} >
                        <Grid item xs={3}>
                            <IconButton onClick={this.addRate}>
                                <AddCircleOutlineIcon  />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} style={{ paddingRight: 4 }}>
                            <OutlinedInput endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                           fullWidth={true}
                                           margin="dense"
                                           onChange={this.changeRate} />
                        </Grid>
                    </Grid>
                }
            </FormControl>
        )
    }
}
export default PickRatesInput;



// WEBPACK FOOTER //
// ./src/components/PickRatesInput.js